import './public-path';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { createMuiTheme } from '@material-ui/core/styles';
import App from './App';
import store from './store';
import './assets/style/style.scss';

import * as serviceWorker from './serviceWorker';
import initAPIConfig from './data-manager/configurations';
const { activeRule } = process.env;

function render(props) {
  const { container } = props;
  const rootContainer = container ? container.querySelector('#root') : document.querySelector('#root');
  ReactDOM.render(<Provider store={store}><App {...props} /></Provider>, rootContainer);
}

// applicaiton can start in dev mode even though it does not work with stitcher
if (!window.__POWERED_BY_QIANKUN__) {
  const theme = createMuiTheme(process.env.theme);
  render({
    theme,
    activeRule: process.env.activeRule,
  });
}

export async function bootstrap() {
  console.log('react app bootstrap');
}

export async function mount(props) {
  render(props);
}

export async function unmount(props) {
  const { container } = props;
  ReactDOM.unmountComponentAtNode(
    container
      ? container.querySelector('#root')
      : document.querySelector('#root'),
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
